import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, CircleMarker, Polyline, Polygon, Circle ,GeoJSON, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import axios from 'axios'
import L from "leaflet";
import bird from '../../../assets/images/img.png'
import { useNavigate, useParams } from 'react-router-dom';
import { useGetAllAreasQuery } from '../../../setup/rtk-query/APIs/areaApi';
import { useGetAllBinsInAreaQuery } from '../../../setup/rtk-query/APIs/binApi';
import green from "../../../assets/images/green-point.png"
import yellow from "../../../assets/images/yellow-point.png"
import blue from "../../../assets/images/blue-point.png"
import { Alert } from 'react-bootstrap';
const AreasMap = ({data}) => {
    const greenIcon = new L.Icon({
        iconUrl: green, // Replace with the actual path to your marker image
        iconSize: [16, 16], // Set the width and height of the icon
      });
    
      const blueIcon = new L.Icon({
        iconUrl: blue, // Replace with the actual path to your marker image
        iconSize: [16, 16], // Set the width and height of the icon
      });
    
      const yellowIcon = new L.Icon({
        iconUrl: yellow, // Replace with the actual path to your marker image
        iconSize: [16, 16], // Set the width and height of the icon
      });

    const navigate = useNavigate();
    const {data:listdata ,isError:listIsError,error:listError, isLoading:listLoading} = useGetAllBinsInAreaQuery(data?._id);

    const [axiosError, setaxiosError] = useState("")
    const [isaxioserror, setisaxioserror] = useState(false)
    const [show, setShow] = useState(true);

    const name = useParams().name?.split("-").join(" ");
    const center = [38.73801726180955, -9.161344238281252]
    const [header, setHeader] = useState("hello")
    const [info, setInfo] = useState("info")
    const [geoInfo, setgeoInfo] = useState([])
    const [geoJsonData, setGeoJsonData] = useState(null);

    const fetchFreguesias = async (municipio) => {
        const response = await axios.get(`https://geoapi.pt/municipio/${municipio}/freguesias?json=1`);
        return response.data.geojsons.freguesias
    };
    const fetchAllData = async () => {
        

        try {
            let lisboaData = await fetchFreguesias('lisboa');
        const combinedData = {
            type: 'FeatureCollection',
            features: [...lisboaData],
        };
        const stateInfo = lisboaData.map(item => ({
            carto_id: item.properties.Dicofre,
            name: item.properties.Freguesia,
            info: `${item.properties.Freguesia} it's a freguesia in ${item.properties.Concelho} Distrito ${item.properties.Distrito}`,
            details: "30"
        }));
        setgeoInfo(stateInfo);

        setGeoJsonData(combinedData)
            setisaxioserror(false)
        } catch (error) {
            setaxiosError(error.message)
            setisaxioserror(true)
        }
    };

    useEffect(() => {
        fetchAllData();
    }, []);

    const onEachState = (state, layer) => {
        if (state.properties && state.properties.Freguesia && state.properties.Dicofre) {
            const clickedState =geoInfo[geoInfo.findIndex(x => x.carto_id === state.properties.Dicofre)];
            const stateOpacity = +clickedState?.details/120 || 0.2;
            // Set the opacity style for the layer
            layer.setStyle({
                fillOpacity: stateOpacity,
                weight: 2,
                opacity: 1,
                color: 'green', // Set the stroke color to black
                dashArray: '3',
                fillColor: "#009F3B",
            });
            if(state.properties.Freguesia.toLowerCase()===data?.name){
                layer.setStyle({
                    color: 'blue', // Set the stroke color to black
                    fillColor: "#2F86A6",
                });
            }

            layer.on({
                mouseover: () => {
                    if(clickedState){
                        setHeader(clickedState?.name)
                        setInfo(clickedState?.info)       
                    }
                    
                    // Change color on hover
                    layer.setStyle({
                        color: 'blue', // Set the stroke color to black
                        fillColor: "#2F86A6",
                    });
                },
                mouseout: () => {
                    // Set the opacity style for the layer
                    layer.setStyle({
                        color: 'green', // Set the stroke color to black
                        fillColor: "#009F3B",
                    });
                    if(state.properties.Freguesia===name){
                        layer.setStyle({
                            color: 'blue', // Set the stroke color to black
                            fillColor: "#2F86A6",
                        });
                    }
                },
                mousemove: (e) => {
                },
                click: () => {
                    navigate(`/areas/${state.properties.Freguesia.split(" ").join("-")}`)
                },
            });
        }
    };

    const navigateToBin = (latitude, longitude) => {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              window.open(
                `https://www.google.com/maps/dir/${position.coords.latitude},${position.coords.longitude}/${latitude},${longitude}`
              );
            },
            (error) => {
              if (error.code === error.PERMISSION_DENIED) {
                // Handle permission denied error
                console.error("Permission denied to access user's location.");
              } else {
                console.error("Error getting current position:", error);
              }
            }
          );
        } else {
          console.error("Geolocation is not supported by your browser");
        }
      };

    return (
        <div>
            {listIsError ? 
            <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                {listError?.data?.error}
            </Alert>
        : ""}
            {isaxioserror ? 
            <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                {axiosError}
            </Alert>
        : ""}
        <MapContainer center={center} zoom={12} className='area-map-height' style={{ width: '100%' }}>
        <TileLayer  
            url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
            attribution='&copy; <a href="https://carto.com/">carto.com</a> contributors'
        />
        {geoJsonData && (
            <GeoJSON
            key={data?.name}
            data={geoJsonData}
            onEachFeature={onEachState}
            >
                <Tooltip sticky>
                    <div className='text-center' style={{ width: "200px", margin: "auto" }}>
                        <h4 style={{ textWrap: "wrap" }}>{header}</h4>
                        {/* <div className='fs-4 fw-bold text-black'>70%</div>
                        <Line trailWidth={4} percent={10} strokeWidth={4} strokeColor="#009f3b" /> */}
                    </div>
                </Tooltip>
            </GeoJSON>
        )}
        {listdata?.data?.map((marker, index) => (
            <Marker key={index} position={[marker?.latitude || marker.lat, marker?.longitude || marker.lng]}
            icon={
                marker.materials.includes("Plastic")
                  ? greenIcon
                  : marker.materials.includes("Glass")
                  ? blueIcon
                  : yellowIcon
              }
              >
                <Popup>
                    <strong>{marker.name}</strong>
                    <br />
                    Materials Accepted: {marker.materials.join(", ")}
                    <br />
                    Address: {marker.address}
                    <button
                      style={
                        marker.materials.includes("Plastic")
                          ? { background: "#009f3b" }
                          : marker.materials.includes("Glass")
                          ? { background: "#1640d6" }
                          : { background: "#f2a800" }
                      }
                      className="location-btn"
                      onClick={() =>
                        navigateToBin(marker.latitude, marker.longitude)
                      }
                    >
                      Take Me There
                    </button>
                  </Popup>
            </Marker>
        ))}
    </MapContainer>
        </div>

    )
}

export default AreasMap